import config from 'config';

import { radioAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(radioAnatomy.keys);

const {
  colors: {
    palette: {
      theme: { radio: styles }
    }
  }
} = config;

const baseStyle = definePartsStyle({
  control: {
    borderColor: styles.radioControlBorderColor,
    opacity: 0.6,
    _checked: {
      bg: styles.radioControlCheckedBg,
      borderColor: styles.radioControlCheckedBorderColor,
      '&::before': {
        bg: styles.radioControlCheckedBeforeBg
      },
      _hover: {
        bg: styles.radioControlHoverBg,
        borderColor: styles.radioControlHoverBorderColor
      }
    }
  }
});

const Radio = defineMultiStyleConfig({ baseStyle });

export default Radio;
